/**
 * Category Search API
 *
 * API function for searching categories
 */

import { buildApiUrl, handleApiResponse } from '@/src/shared/api';
import type { Category, CategorySearchResponse } from '../types';

export interface SearchCategoriesParams {
  search: string;
  page?: number;
  limit?: number;
}

/**
 * Search categories by query string
 */
export async function searchCategories(
  params: SearchCategoriesParams,
): Promise<CategorySearchResponse> {
  const { search, page = 1, limit = 50 } = params;

  if (!search.trim()) {
    return {
      categories: [],
      total: 0,
      page: 1,
      limit,
    };
  }

  const url = buildApiUrl(
    `/categories/public?search=${encodeURIComponent(search)}&limit=${limit}`,
  );

  const response = await fetch(url);
  const data = await handleApiResponse<Category[]>(response);

  return {
    categories: Array.isArray(data) ? data : [],
    total: Array.isArray(data) ? data.length : 0,
    page,
    limit,
  };
}
